import React, { useEffect, useState } from "react";
import cn from "classnames";
import styles from "./Code.module.sass";
import styleMFA from "../../../screens/SignIn/MFA.module.sass";
import Loader from "../../../components/Loader";
import VerificationInput from "react-verification-input";
import { AuthVerify } from "../../../auth";
import { useHistory } from "react-router-dom";

const Code = (props) => {
	const { verifyData, setVerifyData } = props;
	const [loading, setLoading] = useState(false);
	const history = useHistory();

	const handleChange = (value) => {
		if (value.length === 6) {
			setVerifyData((p) => {
				return { ...p, confirmationCode: value };
			});
		} else return;
	};

	const handleVerify = () => {
		if (verifyData.confirmationCode.length === 6) {
			AuthVerify(verifyData, setLoading, history);
		} else return;
	};

	useEffect(() => {
		return () => {
			setLoading(false);
		};
	}, []);

	return (
		<div className={styles.code}>
			<div className={styles.body}>
				<div className={styles.info}>
					We just send you a verify code. Check your inbox to get them.
				</div>
				<div className={styles.fieldset}>
					<VerificationInput
						autoFocus
						validChars="0-9"
						length={6}
						onChange={handleChange}
						classNames={{
							container: styleMFA.container,
							character: `${styleMFA.bit} ${styleMFA.bg_tint_orange}`,
							characterInactive: styleMFA.bit__inactive,
							characterSelected: styleMFA.bit__selected,
						}}
					/>
				</div>
				<div className={styles.errorNote}>
					The code you entered is incorrect.
				</div>
				<button
					className={cn(
						`button ${
							loading || verifyData.confirmationCode.length < 6
								? "disabled"
								: ""
						}`,
						styles.button
					)}
					onClick={handleVerify}
				>
					{loading ? <Loader white /> : <span>Continue</span>}
				</button>
				<div className={styles.note}>
					This site is protected by reCAPTCHA and the Google Privacy Policy.
				</div>
			</div>
		</div>
	);
};

export default Code;
